import { Directive, EventEmitter, Input, Output } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { SelectionModel } from '@angular/cdk/collections';

/** Basic interface for a table component with checkbox selectable rows **/
export interface SelectionTable<T> {
  /* Toggle selection and emit  */
  selectRow(item: T);

  /** Whether the number of selected elements matches the total number of rows. */
  isAllSelected();

  /** Selects all rows if they are not all selected; otherwise clear selection. */
  masterToggle();

  /** Clears the given values from being selected **/
  clearSelection(selection?: T[]);
}

@Directive()
export abstract class SelectionTableBaseComponentDirective<T> implements SelectionTable<T> {
  @Input() set data(data: T[]) {
    this.dataSource.data = data;
  }

  /* Only emits on manual user toggle */
  @Output() selected = new EventEmitter<T[]>();

  dataSource: MatTableDataSource<T>;

  selection = new SelectionModel<T>(true, []);

  displayedColumns = [
    'select',
  ];

  constructor() {
    this.dataSource = new MatTableDataSource<T>([]);
  }

  selectRow(item: T) {
    this.selection.toggle(item);
    this.selected.emit(this.selection.selected);
  }

  abstract masterToggle();

  isAllSelected() {
    const numSelected = this.selection.selected.length;
    const numRows = this.dataSource.data.length;
    return numSelected === numRows;
  }

  clearSelection(selection?: T[]) {
    if (selection) {
      this.selection.deselect(...selection);
    } else {
      this.selection.clear();
    }
  }
}
